/**
 * Format a date in YYYY-MM-DD
 * @param {*} date 
 * @returns 
 */
const formattedDate = (date) => {
    return new Date(date).toISOString().split('T')[0];
};
export default formattedDate;
